<script>
  import router from "page";
  import Home from "./routes/Home.svelte";
  import _404 from "./routes/_404.svelte";

  let page;

  router("/", () => (page = Home));
  // router('/index.html', () => page = Home)
  router("*", () => (page = _404));

  router.start();

  //#region PWA TESTING

  // let pwaBtn = false
  // let deferredPrompt;

  /**	 trigger test */
  // Initialize deferredPrompt for use later to show browser install prompt.

  // function handleBefInstallPrompt(e) {
  // 	// Prevent the mini-infobar from appearing on mobile
  // 	e.preventDefault();
  // 	// Stash the event so it can be triggered later.
  // 	deferredPrompt = e;
  // 	// Update UI notify the user they can install the PWA
  // 	// showInstallPromotion();
  // 	pwaBtn = true
  // // Optionally, send analytics event that PWA install promo was shown.
  // 	console.log(`'beforeinstallprompt' event was fired.`, deferredPrompt);
  // }

  // const promptPWAEvent = async () => {
  // 	console.log('👍', 'butInstall-clicked');
  // 	const promptEvent = deferredPrompt;
  // 	if (!promptEvent) {
  // 		// The deferred prompt isn't available.
  // 		return;
  // 	}
  // 	// Show the install prompt.
  // 	promptEvent.prompt();
  // 	// Log the result
  // 	const result = await promptEvent.userChoice;
  // 	console.log('👍', 'userChoice', result);
  // 	// Reset the deferred prompt variable, since
  // 	// prompt() can only be called once.
  // 	pwaBtn = false
  // 	deferredPrompt = null;
  // 	// Hide the install button.
  // }

  // function handleInstalled(event){
  // 	console.log('👍', 'appinstalled', event);
  // 	pwaBtn = false
  // 	// Clear the deferredPrompt so it can be garbage collected
  // 	deferredPrompt = null;
  // }

  //#endregion PWA TESTING
</script>

<svelte:head>
  <link rel="preconnect" href="https://fonts.googleapis.com" />
  <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />
  <link
    href="https://fonts.googleapis.com/css2?family=Great+Vibes&display=swap"
    rel="stylesheet"
  />
  <style>
    @import url("https://fonts.googleapis.com/css2?family=Great+Vibes&display=swap");
  </style>
</svelte:head>

<!-- PWA TESTING TEMPLATE ELEMENTS
	
<svelte:window on:beforeinstallprompt={handleBefInstallPrompt} on:appinstalled={handleInstalled}/>
{#if pwaBtn}	 
<button on:click|once={promptPWAEvent}>Install</button>
{/if} 

-->

<svelte:component this={page} />

<style global>
  :global(h1) {
    font-family: "Great Vibes", cursive;
  }
  :global(h2) {
    font-size: 2.5em;
  }
  :global(h3) {
    font-size: 2em;
  }
  :global(::selection) {
    background-color: white;
  }
  :global(html) {
    color: #384b54;
  }
  :global(html) {
    font-family: GillSans, Calibri, Trebuchet, sans-serif;
  }
  :global(.section) {
    background-color: #efebe9;
  }
  :global(strong) {
    font-weight: 700;
  }
  :global(a) {
    color: #00838f;
  }
  :global(a:hover) {
    color: #0097a7;
    text-decoration: underline;
    text-decoration-style: wavy;
  }
  :global(body) {
    width: 100%;
    margin: 0;
  }
  :global(canvas) {
    width: 100%;
    height: 100vh;
    position: fixed;
    z-index: -999999;
  }
  :global(.divider) {
    clear: both;
  }

  :global(img.materialboxed:nth-child(2)) {
    height: 80vh !important;
    width: auto !important;
    max-height: 1200px !important;
    top: 50% !important;
    left: 50% !important;
    position: fixed !important;
    transform: translate(-50%, -50%) !important;
  }
  @media screen and (max-width: 700px) {
    :global(img.materialboxed:nth-child(2)) {
      width: 450px !important;
      height: auto !important;
    }
  }
  :global(.material-placeholder) {
    height: 250px;
  }
  :global(.material-icons img) {
    filter: opacity(50%);
  }
</style>
